import { request } from './http';
import type { UpstreamAccountBalance } from '@/types/reconcile';

export const adminReconcileApi = {
  fetchUpstreamBalance() {
    return request<UpstreamAccountBalance>({
      url: '/admin/reconcile/upstream-balance',
      method: 'POST',
    });
  },
};
